const STORAGE_PREFIX = 'noteTypeFilters';

const getStorage = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }
  return window.localStorage;
};

const buildStorageKey = (userId) => {
  const safeUserId = userId || 'anonymous';
  return `${STORAGE_PREFIX}:${safeUserId}`;
};

export const loadNoteFiltersFromStorage = (userId) => {
  try {
    const storage = getStorage();
    if (!storage) return null;
    const storedValue = storage.getItem(buildStorageKey(userId));
    return storedValue
      ? JSON.parse(storedValue)
      : null;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to load note filters from storage', error);
    return null;
  }
};

export const saveNoteFiltersToStorage = (userId, filters) => {
  try {
    const storage = getStorage();
    if (!storage) return;
    storage.setItem(
      buildStorageKey(userId),
      JSON.stringify(filters || []),
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to save note filters to storage', error);
  }
};
